"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("./Icon"));
var Button = (0, react_1.forwardRef)(function (_a, ref) {
    var text = _a.text, onClick = _a.onClick, children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, className = _a.className, highlighted = _a.highlighted, disabled = _a.disabled, icon = _a.icon, _c = _a.iconButtonSize, iconButtonSize = _c === void 0 ? 'medium' : _c, _d = _a.iconSize, iconSize = _d === void 0 ? 'xsmall' : _d;
    var isIconOnly = !!icon && !text && !children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-button", disabled && "disabled", highlighted && "highlighted", "ui-button-" + variant, isIconOnly && 'ui-button-icon-only ui-button-icon-' + iconButtonSize, className), role: "button", onClick: disabled ? undefined : function () { return onClick(); }, ref: ref },
        icon ? (react_1.default.createElement(Icon_1.default, { icon: icon, className: "ui-button-icon", size: iconSize })) : null,
        text ? react_1.default.createElement("span", { className: "ui-button-text" }, text) : null,
        children ? react_1.default.createElement("div", { className: "ui-button-content" }, children) : null));
});
exports.default = Button;
